import { Alert, Spin } from '@pankod/refine-antd'
import { useEffect, useState } from 'react'
import { getWarehouseReviewDecision, localWarehouseReviewDecision, needsWarehouseReview, WarehouseReviewDecision } from 'utility/warehouseReview'
import { requiresWarehouseReview } from 'utility/warehouseReviewChecklist'

type Props = { order: any }

export const WarehouseReviewDecisionBanner: React.FC<Props> = ({ order }) => {
  const [decision, setDecision] = useState<WarehouseReviewDecision | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let active = true
    const localDecision = localWarehouseReviewDecision(order)
    if (!needsWarehouseReview(order)) {
      setDecision(null)
      setLoading(false)
      return () => { active = false }
    }
    if (localDecision) {
      setDecision(localDecision)
      setLoading(false)
      return () => { active = false }
    }
    setLoading(true)
    getWarehouseReviewDecision(order.id)
      .then((result) => active && setDecision(result))
      .catch(() => active && setDecision(null))
      .finally(() => active && setLoading(false))
    return () => { active = false }
  }, [order])

  if (!needsWarehouseReview(order)) return null

  if (loading) return <Alert showIcon type="info" message={<><Spin size="small" /> Comprobando si es necesario revisar el pedido…</>} />

  if (requiresWarehouseReview(decision)) {
    return <Alert
      showIcon
      type="error"
      message="REVISAR PEDIDO"
      style={{ width: '100%', minHeight: 72, display: 'flex', alignItems: 'center' }}
    />
  }

  return <Alert
    showIcon
    type="success"
    message="NO ES NECESARIO REVISAR"
    style={{ width: '100%', minHeight: 72, display: 'flex', alignItems: 'center' }}
  />
}
